// extracted by mini-css-extract-plugin
export default {"popover-content":"Content-module__popover-content___aogX6","popover-content_without-paddings":"Content-module__popover-content_without-paddings___unIMo"};